export enum FileNotificationType {
  Accepted,
  NotAccepted,
}
